module.exports = __webpack_public_path__ + "img/9788960172715.56284759.jpg";